import React from "react";
import { Box, Checkbox } from "@mui/material";
import { useDispatch } from "react-redux";
import {
  useSolutionType,
  useSystemConfig,
  useDeviceConfigEntries,
  useOverviewUI,
  useSystemId,
} from "../../../hooks/useReduxSelectors";
import { setDiagnosticsPickerList } from "../../../ducks/uiDuck";
import { refreshSignalR } from "../../../../Dashboard/ducks/devicesDuck";

const DiagnosticsPicker = React.memo(({ hwId }) => {
  const systemId = useSystemId();
  const solutionType = useSolutionType();
  const config = useSystemConfig();
  const configEntries = useDeviceConfigEntries();
  const deviceConfig =
    configEntries && configEntries.find((dev) => dev.hwId === hwId);
  const diagnostics = deviceConfig && deviceConfig.diagnostics;
  const diagnosticsPickerList = useOverviewUI()?.diagnosticsPickerList;
  const dispatch = useDispatch();

  const onClickDiagnosticsPicker = (item) => {
    dispatch(
      setDiagnosticsPickerList({
        systemId,
        data: {
          displayName: item.name,
          valueName: item.valueName,
          hwId: hwId,
        },
      })
    );
    if (systemId !== "edge" && config && solutionType === "lora") {
      dispatch(
        refreshSignalR({
          hwId: hwId,
          payload: {
            ...config,
          },
          // customerId: config.CUSTOMER_ID, 
          // deviceId: config.DEVICE_ID,
          delay: 1000
        })
      );
    }
  };

  return (
    <Box>
      {diagnostics &&
        diagnostics.length > 0 &&
        diagnostics.map((item, index) => {
          const filter = (diagnosticsPickerList || []).filter(
            (diagnosticItem) =>
              diagnosticItem.valueName === item.valueName &&
              diagnosticItem.hwId === hwId
          );
          return (
            <div
              role="presentation"
              key={`${item.name}_diagnosticPicker_${index}`}
              onClick={() => {
                onClickDiagnosticsPicker(item);
              }}
            >
              <Checkbox color="secondary" checked={filter && filter.length > 0} size="small" />
              <span>{item.name}</span>
            </div>
          );
        })}
    </Box>
  );
});



export default DiagnosticsPicker;
